export enum MessageTypeEnum {
  Email = 'EMAIL',
  LinkedinManual = 'LINKEDIN_MANUAL',
}
